import { Controller } from "stimulus"
import Constants from '../classes/Constants';
import { h, render, Fragment } from 'preact'
import { useState, useCallback, useEffect, useRef } from 'preact/hooks'
import Events from '../classes/Events';

const dropdownMapping = {
  investorTypes: Constants.InvestorTypes,
  countries: Constants.Countries
}

class Dropdown extends Controller {
  connect() {
    this.preprocessData();
    render(<DropdownList dropdownData={this.dropdownList} inputRef={this.element} />, this.element.parentNode);
  }

  preprocessData() {
    this.dropdownType = this.data.get('list-type');
    const rawData = dropdownMapping[this.dropdownType];
    this.dropdownList = rawData.reduce((acc, heading) => {
      const { type, entities } = heading;
      if (type) {
        acc.push({
          type: 'heading',
          name: type
        })
      }
      entities.forEach(entity => {
        const { name, value } = entity;
        acc.push({
          type: 'entry',
          name,
          value
        })
      })
      return acc;
    }, []);
  }
}


const useDropdown = () => {
  const [showDropdown, setShow] = useState(false);
  const toggleDropdown = useCallback((assignedState = null) => {
    if (assignedState != null) {
      setShow(assignedState)
    } else {
      setShow(prevShow => !prevShow)
    }
  }, [showDropdown])

  return {
    showDropdown,
    toggleDropdown
  }
}

const DropdownList = ({dropdownData, inputRef}) => {
  const { showDropdown, toggleDropdown } = useDropdown();
  const [dropdownName, setName] = useState(null);
  const [dropdownValue, setValue] = useState(null);
  const dropdownContainer = useRef(null);

  useEffect(() => {
    if(dropdownName) inputRef.value = dropdownName;
  }, [dropdownName]);

  useEffect(() => {
    if (dropdownValue) {
      inputRef.setAttribute('data-dropdown-value', dropdownValue);
      inputRef.dispatchEvent(Events.changeEvent)
    }
  }, [dropdownValue]);

  const handleClickAway = e => {
    const { target } = e;
    if (!dropdownContainer.current.contains(target)) {
      toggleDropdown(false);
    }
  };

  useEffect(() => {
    if (document) {
      if (showDropdown) {
        document.addEventListener('click', handleClickAway);
      } else {
        document.removeEventListener('click', handleClickAway);
      }
      return () => {
        document.removeEventListener('click', handleClickAway);
      }
    }
  }, [showDropdown])

  return (
    <Fragment>
      <div ref={dropdownContainer} className="dropdown-container t-absolute t-top-0 t-left-0 t-w-full t-h-full t-bg-transparent t-cursor-pointer" onClick={() => toggleDropdown()} />
      {
        showDropdown && (
          <div className="dropdown-options-container t-absolute t-w-full t-shadow-strong t-rounded t-border t-border-gray-750 t-top-0 t-left-0 t-bg-white t-flex t-flex-col t-z-11 t-max-h-60 t-overflow-y-auto t-py-1">
            {
              dropdownData.map(dropdown => (
                dropdown.type === 'entry' ? (
                  <div className="t-bg-white hover:t-bg-gray-150 t-text-left t-cursor-pointer" onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    setName(dropdown.name);
                    setValue(dropdown.value);
                    toggleDropdown();
                  }}>
                    <p className="dropdown-option-text t-ml-4 t-text-gray-725 t-my-2 t-text-md">
                      {dropdown.name}
                    </p>
                </div>
                ) : (
                  <div className="t-my-1 t-mx-4 t-bg-white t-text-left t-uppercase">
                    <div className="t-w-full t-h-px t-bg-gray-750 t-mb-3" />
                    <p className="t-text-gray-650 t-text-3xs t-font-semibold">
                      {dropdown.name}
                    </p>
                  </div>
                )
              ))
            }
          </div>
        )
      }
    </Fragment>
  )
}

export default Dropdown;
